import React from "react";
import { observer } from "mobx-react";
import { Button, Typography } from "@material-ui/core";

import LoadingButton from "components/LoadingButton";
import {
  withGlobalSnackbar,
  SnackbarContextProps,
} from "services/snackbar/snackbarContext";

import SubmitButtonControl from "components/FormControl/SubmitButtonControl";
import {
  GroupRow,
  Container,
  Buttons,
  ButtonContainer,
  TitleContainer,
} from "./styles";
import FormControl, { TextFieldControl } from "components/FormControl";
import DropdownFieldControl from "components/FormControl/DropdownFieldControl";
import { lengthValidator } from "utils/validators";
import { Question } from "pages/Content/Trivia/TriviaStore";

const requiredOptions = [
  {
    value: "true",
    label: "Yes",
  },
  {
    value: "false",
    label: "No",
  },
];

type Props = {
  onClose: () => void;
  onSubmit: (v: any) => void;
  isLoading: boolean;
  question: Question;
  isEditMode: boolean;
} & SnackbarContextProps;

const AddQuestionForm = ({
  onClose,
  onSubmit,
  isLoading = false,
  question,
  isEditMode = false,
}: Props) => {
  const transformedQuestion = {
    ...question,
    isRequired: question?.isRequired ? "true" : "false",
  };

  return (
    <>
      <Container>
        <TitleContainer>
          <Typography variant="h1" color="textPrimary">
            {isEditMode ? "Edit Question" : "Add Question"}
          </Typography>
        </TitleContainer>
      </Container>

      <FormControl
        onSubmit={onSubmit}
        initialValues={isEditMode ? transformedQuestion : {}}
        keepDirtyOnReinitialize={true}
      >
        <GroupRow>
          <TextFieldControl
            variant="outlined"
            margin="none"
            name="title"
            label="Title"
            validate={lengthValidator(64)}
            fullWidth
            required
          />
        </GroupRow>
        <GroupRow>
          <TextFieldControl
            variant="outlined"
            margin="none"
            name="code"
            label="Code"
            validate={lengthValidator(32)}
            fullWidth
            required
          />
        </GroupRow>
        <GroupRow>
          <TextFieldControl
            variant="outlined"
            margin="none"
            name="complement"
            label="Complement"
            validate={lengthValidator(128)}
            fullWidth
            required
          />
        </GroupRow>
        <GroupRow>
          <DropdownFieldControl
            name="isRequired"
            options={requiredOptions}
            label="Required"
            multi={false}
            isClearable
            required
          />
        </GroupRow>

        <Buttons>
          <ButtonContainer>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
          </ButtonContainer>

          <ButtonContainer>
            <SubmitButtonControl
              render={({ onClick }: any) => {
                return (
                  <LoadingButton
                    onClick={onClick}
                    variant="contained"
                    color="primary"
                    isLoading={isLoading}
                    fullWidth
                  >
                    {isEditMode ? "Save" : "Add"}
                  </LoadingButton>
                );
              }}
            />
          </ButtonContainer>
        </Buttons>
      </FormControl>
    </>
  );
};

export default withGlobalSnackbar(observer(AddQuestionForm));
